<template>
  <button
    :type="typeBtn"
    class="btn"
    :class="[
      background,
      gradient,
      outline,
      rounded,
      size,
      block,
      {
        'btn-medium': btnMedium,
        'btn-center': btnCenter,
        'btn-left': btnLeft,
        'btn-right': btnRight,
      },
    ]"
    :active="active"
    :disabled="disabledBtn"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "btn",
  props: {
    background: {
      type: String,
    },
    gradient: {
      type: String,
    },
    outline: {
      type: String,
    },
    rounded: {
      type: String,
    },
    typeBtn: {
      type: String,
      default: "button",
    },
    size: {
      type: String,
      default: "",
    },
    block: {
      type: String,
      default: "",
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabledBtn: {
      type: Boolean,
      default: false,
    },
    btnMedium: {
      type: Boolean,
      default: true,
    },
    btnCenter: {
      type: Boolean,
      default: true,
    },
    btnLeft: {
      type: Boolean,
      default: false,
    },
    btnRight: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.btn-medium {
  max-width: 300px;
}

.btn-center {
  margin: 50px auto;
}

.btn-left {
  margin-left: 0;
}

.btn-right {
  margin-right: 0;
}

.btn {
  font-size: 1.4rem;
  box-shadow: none;
  height: 58px;
  line-height: 1.8;
  border-radius: 4px;
}

.bg-primary-dominos {
  background-color: #006491;
  color: #fff;
}

.btn:hover {
  color: #fff;
  box-shadow: none;
}

@media screen and (max-width: 580px) {
  .btn {
    font-size: 20px;
    box-shadow: none;
    height: 50px;
    line-height: 1.4;
  }
}
</style>
